import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {PrimeNGModule} from '../../core';

import {CustomerCreationPage, CustomerDetailsPage, CustomerListPage} from './pages/';
import {CustomerRoutingModule} from './customer-routing.module';
import {CustomerService} from '../../core/services';
import {SharedModule} from '../../shared/share.module';


@NgModule({
  imports: [CommonModule, CustomerRoutingModule, PrimeNGModule, SharedModule],
  declarations: [CustomerListPage, CustomerDetailsPage, CustomerCreationPage],
  providers: [CustomerService]
})
export class CustomerModule {
}
